module.exports = __webpack_public_path__ + "img/Menu-Get_15.3404faf3.png";